import React from "react";
import injectSheet from "react-jss";
import classNames from "classnames";

const RequiredStarOther = ({ classes, className, description }) => {
  return (
    <span className={classNames(classes.star, className)} title={description}>
      &#42;
    </span>
  );
};

const styles = {
  star: {
    color: "red",
    fontSize: "18px",
    lineHeight: "1px",
  },
};
export default injectSheet(styles)(RequiredStarOther);
